const syncAriaHiddenFocus = (slider) => {
  const focusableSelector =
    'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const update = () => {
    slider.slides.forEach((slide) => {
      const isHidden = slide.getAttribute("aria-hidden") === "true";
      const focusables = slide.querySelectorAll(focusableSelector);

      if (isHidden) {
        slide.setAttribute("inert", "");
        focusables.forEach((el) => {
          if (el.hasAttribute("data-prev-tabindex")) return;
          const prev = el.getAttribute("tabindex");
          el.setAttribute("data-prev-tabindex", prev === null ? "" : prev);
          el.setAttribute("tabindex", "-1");
        });
      } else {
        slide.removeAttribute("inert");
        focusables.forEach((el) => {
          if (!el.hasAttribute("data-prev-tabindex")) return;
          const prev = el.getAttribute("data-prev-tabindex");
          if (prev === "") {
            el.removeAttribute("tabindex");
          } else {
            el.setAttribute("tabindex", prev);
          }
          el.removeAttribute("data-prev-tabindex");
        });
      }
    });
  };

  slider.on("created", update);
  slider.on("detailsChanged", update);
  slider.on("slideChanged", update);
  slider.on("updated", update);
};

// Drupal behavior to init Keen Slider only when its library attached
if (window.Drupal && window.once) {
  (function (Drupal, once) {
    Drupal.behaviors.b5novaKeenSlider = {
      attach(context) {
        try {
          // Exclude progress-bar slider containers to avoid double initialisation conflicts.
          const selector = ".keen-slider:not(.js-progress-bar-keen-slider)";
          once("b5nova-keen-slider", selector, context).forEach((container) => {
            if (!(window.keen && window.keen.KeenSlider)) return;
            const wrapper = container.closest(".keen-slider-region");
            const plugins = [
              window.keen.Keyboard,
              window.keen.Accessibility,
              syncAriaHiddenFocus,
              window.keen.AutoPlay(3000, true, true),
              window.keen.Lazy({ lazyPreloadNext: 2 }),
            ];
            if (wrapper && wrapper.querySelector(".keen-slider__arrows")) {
              plugins.push(window.keen.Arrows);
            }
            if (
              wrapper &&
              wrapper.querySelector(".keen-slider__bullets-list")
            ) {
              plugins.push(window.keen.Bullets);
            }
            new window.keen.KeenSlider(
              container,
              {
                loop: true,
                slides: { perView: 1 },
                breakpoints: {
                  [window.keen.minBreakpoint("sm")]: { slides: { perView: 1 } },
                  [window.keen.minBreakpoint("md")]: { slides: { perView: 2 } },
                  [window.keen.minBreakpoint("lg")]: { slides: { perView: 3 } },
                  [window.keen.minBreakpoint("xl")]: { slides: { perView: 3 } },
                },
              },
              plugins
            );
          });
        } catch (e) {
          // no-op
        }
      },
    };
  })(window.Drupal, window.once);
}
